export default class ScoreHistory {
  static key(wordlength) {
    return `eldrow_scores_${wordlength}`
  }

  static save(wordlength, score, guessCount) {
    const scores = this.all(wordlength)
    scores.push({ score, guessCount, date: new Date().toISOString() })
    localStorage.setItem(this.key(wordlength), JSON.stringify(scores))
  }

  static all(wordlength) {
    const raw = localStorage.getItem(this.key(wordlength))
    return raw ? JSON.parse(raw) : []
  }

  static topTen(wordlength) {
    return this.all(wordlength)
      .sort((a, b) => b.score - a.score)
      .slice(0, 10)
  }

  static SESSION_KEY = 'eldrow_session'

  static saveSession(data) {
    localStorage.setItem(this.SESSION_KEY, JSON.stringify(data))
  }

  static loadSession() {
    const raw = localStorage.getItem(this.SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  }

  static clearSession() {
    localStorage.removeItem(this.SESSION_KEY)
  }
}
